import React, { useEffect, useRef } from 'react';
import './ZoomModal.css';

export default function ZoomModal({ onClose, children }) {

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div className="zoom-modal-overlay">
      <div className="zoom-modal" ref={modalRef}>
        <button className="zoom-close-btn" onClick={() => {
          console.log("Close button clicked");
          onClose();
        }}>×</button>
        <div className="zoom-modal-content">{children}</div>
      </div>
    </div>
  );
}
